import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import autobind from 'react-autobind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FormBase from '../FormBase';

import SignUp from './SignUp';
import TermsAndConditions from './TermsAndConditions';
import Finish from './Finish';
import MetaComponent from '../../components/MetaTags';

import {
  changeStep,
  updatePatientInfo,
  submitForm,
  clearEnrollForm,
} from '../../actions/hpsEnrollForm';
import { homeRedirectOnFinish } from '../../utils/utils';

class HPSEnroll extends Component {
  constructor (props) {
    super(props);
    autobind(this);
    const { dispatch } = props;
    this.boundActionCreators = bindActionCreators({
      changeStep,
      updatePatientInfo,
      submitForm,
      clearEnrollForm,
    }, dispatch);
    this.state = {
      path: '',
      formReady: false,
      signUpTreatment: '',
    };
    this.lastPathname = props.location.pathname;
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (!nextProps.isLoading && (nextProps.success.status || nextProps.error.code) && !prevState.formReady) {
      if (nextProps.location.pathname.includes('casemanagers')) {
        nextProps.history.push(`/casemanagers/${nextProps.match.params.environment}${prevState.path}`);
      } else {
        nextProps.history.push(`/${nextProps.match.params.environment}${prevState.path}`);
      }
      return {
        ...prevState,
        formReady: true,
      };
    }
    return prevState;
  }

  componentDidMount () {
    window.addEventListener('popstate', this.handleBackButton);
  }

  componentWillUnmount () {
    this.setState({
      formReady: false,
    });
    this.props.dispatch(clearEnrollForm());
    window.removeEventListener('popstate', this.handleBackButton);
  }

  componentDidUpdate (prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.lastPathname = prevProps.location.pathname;
    }
  }

  handleBackButton () {
    const { history, match } = this.props;

    homeRedirectOnFinish(history, match, this.lastPathname, 'hps');
  }

  handleOnChangeField (payload) {
    const { dispatch } = this.props;
    dispatch(updatePatientInfo(payload));
  }

  handleOnSubmitForm = ({ values, path }) => {
    this.handleOnChangeField(values);
    this.setState({
      path,
    });
    this.props.dispatch(submitForm());
  };

  handleOnSubmitSignUp = ({ values, path }) => {
    this.handleOnChangeField(values);
    if (this.props.location.pathname.includes('casemanagers')) {
      this.props.history.push(`/casemanagers/${this.props.match.params.environment}${path}`);
    } else {
      this.props.history.push(`/${this.props.match.params.environment}${path}`);
    }
  };

  updateSignTreatment = (treatment) => {
    this.setState({
      signUpTreatment: treatment,
    });
  }

  render () {
    const { params } = this.props.match;
    const formType = 'enroll';
    const { drugAnswers } = this.props.patientInformation;
    const { status } = this.props.success;
    const { code } = this.props.error;

    return (
      <FormBase
        environment={ params.environment }
        customClass="form hps-screen"
        isLoading={ this.props.isLoading }
      >
        <Switch>
          <Route
            path={ `/${params.environment}/hps/enroll/eligibility` }
            component={ props =>
              !this.props.source
                ? (
                  <Redirect to="/" />
                )
                : (
                  <React.Fragment>
                    <MetaComponent
                      title="Eligibility | Takeda Oncology Co-Pay Assistance Program"
                      ogMetas={ [{ property: 'og:title', content: 'Eligibility | Takeda Oncology Co-Pay Assistance Program' },
                        { property: 'og:url', content: `https://www.takedaoncologycopay.com/${params.environment}/hps/enroll/eligibility` }] }
                      canonicalLink={ `/${params.environment}/hps/enroll/eligibility` }
                    />
                    <TermsAndConditions
                      environment={ params.environment }
                      onSubmit={ this.handleOnSubmitSignUp }
                      formType={ formType }
                    />
                  </React.Fragment>
                ) }
          />
          <Route
            path={ `/${params.environment}/hps/enroll/patient-information` }
            component={ props =>
              drugAnswers.hasMedicaid === null
                ? (
                  <Redirect to={ `/${params.environment}/hps/enroll/eligibility` } />
                )
                : (
                  <React.Fragment>
                    <MetaComponent
                      title="Patient Information | Takeda Oncology Co-Pay Assistance Program"
                      ogMetas={ [{ property: 'og:title', content: 'Patient Information | Takeda Oncology Co-Pay Assistance Program' },
                        { property: 'og:url', content: `https://www.takedaoncologycopay.com/${params.environment}/hps/enroll/patient-information` }] }
                      canonicalLink={ `/${params.environment}/hps/enroll/patient-information` }
                    />
                    <SignUp
                      environment={ params.environment }
                      onSubmit={ this.handleOnSubmitForm }
                      formType={ formType }
                    />
                  </React.Fragment>
                )
            }
          />
          <Route
            path={ `/${params.environment}/hps/enroll/finish` }
            component={ props =>
              !status && !code
                ? (
                  <Redirect to="/" />
                )
                : (
                  <React.Fragment>
                    <MetaComponent
                      title="Success | Takeda Oncology Co-Pay Assistance Program"
                      ogMetas={ [{ property: 'og:title', content: 'Success | Takeda Oncology Co-Pay Assistance Program' },
                        { property: 'og:url', content: `https://www.takedaoncologycopay.com/${params.environment}/hps/enroll/finish` }] }
                      canonicalLink={ `/${params.environment}/hps/enroll/finish` }
                    />
                    <Finish
                      environment={ params.environment }
                      cardId={ this.props.success.cardNumber || '' }
                      cardBin={ this.props.success.cardBin || '' }
                      cardPcn={ this.props.success.cardPcn || '' }
                      groupId={ this.props.success.cardGroup || '' }
                      enrollmentStatus={ this.props.success.status || '' }
                      enrollmentError={ this.props.error.code || '' }
                    />
                  </React.Fragment>
                )
            }
          />

          {/* casemanagers routes */}
          <Route
            path={ `/casemanagers/${params.environment}/hps/enroll/eligibility` }
            component={ props =>
              (<React.Fragment>
                <MetaComponent
                  title="Eligibility | Takeda Oncology Co-Pay Assistance Program"
                  ogMetas={ [{ property: 'og:title', content: 'Eligibility | Takeda Oncology Co-Pay Assistance Program' },
                    { property: 'og:url', content: `https://www.takedaoncologycopay.com/casemanagers/${params.environment}/hps/enroll/eligibility` }] }
                  canonicalLink={ `/casemanagers/${params.environment}/hps/enroll/eligibility` }
                />
                <TermsAndConditions
                  environment={ params.environment }
                  onSubmit={ this.handleOnSubmitSignUp }
                  formType={ formType }
                  signUpTreatment={ this.state.signUpTreatment }
                  updateSignTreatment={ this.updateSignTreatment }
                />
              </React.Fragment>)
            }
          />
          <Route
            path={ `/casemanagers/${params.environment}/hps/enroll/patient-information` }
            component={ props =>
              (<React.Fragment>
                <MetaComponent
                  title="Patient Information | Takeda Oncology Co-Pay Assistance Program"
                  ogMetas={ [{ property: 'og:title', content: 'Patient Information | Takeda Oncology Co-Pay Assistance Program' },
                    { property: 'og:url', content: `https://www.takedaoncologycopay.com/casemanagers/${params.environment}/hps/enroll/patient-information` }] }
                  canonicalLink={ `/casemanagers/${params.environment}/hps/enroll/patient-information` }
                />
                <SignUp
                  environment={ params.environment }
                  onSubmit={ this.handleOnSubmitForm }
                  formType={ formType }
                />
              </React.Fragment>)
            }
          />
          <Route
            path={ `/casemanagers/${params.environment}/hps/enroll/finish` }
            component={ props =>
              !status && !code
                ? (
                  <Redirect to="/" />
                )
                : (
                  <React.Fragment>
                    <MetaComponent
                      title="Success | Takeda Oncology Co-Pay Assistance Program"
                      ogMetas={ [{ property: 'og:title', content: 'Success | Takeda Oncology Co-Pay Assistance Program' },
                        { property: 'og:url', content: `https://www.takedaoncologycopay.com/casemanagers/${params.environment}/hps/enroll/finish` }] }
                      canonicalLink={ `/casemanagers/${params.environment}/hps/enroll/finish` }
                    />
                    <Finish
                      environment={ params.environment }
                      cardId={ this.props.success.cardNumber || '' }
                      cardBin={ this.props.success.cardBin || '' }
                      cardPcn={ this.props.success.cardPcn || '' }
                      groupId={ this.props.success.cardGroup || '' }
                      enrollmentStatus={ this.props.success.status || '' }
                      enrollmentError={ this.props.error.code || '' }
                    />
                  </React.Fragment>
                )
            }
          />
        </Switch>
      </FormBase>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.hpsEnrollForm.loading,
  patientInformation: state.hpsEnrollForm.patientInformation,
  success: state.hpsEnrollForm.success,
  error: state.hpsEnrollForm.error,
  source: state.options.source,
});

export default withRouter(connect(mapStateToProps)(HPSEnroll));
